
import api from "./api";
import { AgentModule } from "../types";

/**
 * Fetch enriched strategy data from backend for executive mode
 */
const enrichStrategyContext = async (): Promise<Record<string, any>> => {
  try {
    const [quotes, util, fatigue, market] = await Promise.all([
      api.get('/strategy/quotes-summary').catch(() => ({ data: { data: { quotes: [] } } })),
      api.get('/strategy/fleet-utilization').catch(() => ({ data: { data: {} } })),
      api.get('/strategy/pilot-fatigue').catch(() => ({ data: { data: {} } })),
      api.get('/strategy/market-intelligence').catch(() => ({ data: { data: {} } })),
    ]);
    return {
      quotes: quotes.data?.data,
      utilization: util.data?.data,
      fatigue: fatigue.data?.data,
      market: market.data?.data,
    };
  } catch (err) {
    console.warn('Strategy context enrichment failed:', err);
    return {};
  }
};

/**
 * Service to query the Miracle Air Operational Assistant
 */
export const queryAgent = async (
  prompt: string,
  context: string,
  imageBase64?: string,
  mode: 'EXECUTIVE' | 'OPERATIONAL' = 'OPERATIONAL',
  module?: AgentModule
) => {
  // Enrich context with real backend data for executive mode
  let enrichedContext = context;
  if (mode === 'EXECUTIVE') {
    try {
      const strategyData = await enrichStrategyContext();
      enrichedContext = `${context}\n\nLIVE STRATEGY DATA:\n${JSON.stringify(strategyData, null, 2)}`;
    } catch (err) {
      // Silent fallback if enrichment fails
    }
  }

  try {
    const token = localStorage.getItem('ma_jwt') || '';
    const response = await api.post(
      `/agent/query${token ? `?token=${encodeURIComponent(token)}` : ''}`,
      {
        message: prompt,
        context: enrichedContext,
        imageBase64,
        mode,
        module,
      },
      {
        headers: token ? { Authorization: `Bearer ${token}`, 'X-Access-Token': token } : undefined,
      }
    );
    return response.data?.data?.text || response.data?.text || 'No response from agent.';
  } catch (error) {
    console.error('Agent API Error:', error);
    return 'Agent uplink failed. Please contact admin or retry.';
  }
};
